const EventEmitter = require('events').EventEmitter
var moment = require('moment')
moment.locale('it')
import axios from './tAxios'
import storage from './tStorage'

import dbItem from './dbItem'


class socio{
   constructor (args) {
      this.event = new EventEmitter()
      this.moment = moment
      this.societa = 100
      this.sigla = 'SIP'
      this.contatto = new dbItem({database:'sip_limmsy',table:'contatto'})
      this.si = new dbItem({table:'statoiscrizione'})
      this._societa = []
      this._si = []
      this._rinnovo = []
      this._versamento = []
      this._mezzo = []
      this._assicurazione = []
      this._nextquoteDetail = []
      this._nextquote = []


      axios.query('fetchAll',`SELECT * FROM mezzo WHERE 1 ORDER BY nome`,{id: this.contatto.row.id},this,'_mezzo')
      axios.query('fetchAll',`SELECT * FROM societa WHERE attivo=1 ORDER BY peso,tipo,sigla,nome`,{id: this.contatto.row.id},this,'_societa')



      this.contatto.event.on('loaded', () =>{

         storage.save('socio',this.contatto.row.id)
         this.init()

         
          
      })
      
      return this
   }

   getSi(){
      axios.query('fetchOne',`SELECT id FROM statoiscrizione WHERE contatto=→id AND societa=→societa ORDER BY id`,{id: this.contatto.row.id, societa: this.societa}).then((response) =>  {
         this.si.load(response.result)
      })
   }

   getStatoiscrizione(){
      axios.query('fetchAll',`SELECT si.* FROM statoiscrizione AS si LEFT JOIN societa ON societa.id=si.societa WHERE contatto=→id AND societa.attivo=1 and societa.esterno=1 ORDER BY societa.peso, si.id`,{id: this.contatto.row.id, societa: this.societa},this,'_si')
   }
   
   getRrinnovi(){
      axios.query('fetchAll',`SELECT * FROM rinnovo WHERE contatto=→id ORDER BY societa,anno DESC`,{id: this.contatto.row.id},this,'_rinnovo')
   }
   
   getVersamenti(){
      axios.query('fetchAll',`SELECT * FROM versamento WHERE contatto=→id ORDER BY eseguitoil DESC`,{id: this.contatto.row.id},this,'_versamento')
   }
   
   async getAssicurazione(){
      axios.query('fetchAll',`SELECT * FROM aonback WHERE contatto=→id ORDER BY vrsdata DESC, qtsigla`,{id: this.contatto.row.id},this,'_assicurazione')
      return new Promise((resolve, reject) => {resolve("Fatto")})
   }

   getNextquote(){
      axios.query('fetchAll',`call next_quote(→id,→sezione,'summary')`,{id: this.contatto.row.id,sezione:this.societa/100},this,'_nextquote')
   }

   getNextquoteDetail(){
      axios.query('fetchAll',`call next_quote(→id,→sezione,'detail')`,{id: this.contatto.row.id,sezione:this.societa/100},this,'_nextquoteDetail')
   }


   async init(){
      if(this.contatto.row.ruolo<1)
         this.contatto.row.ruolo=''
      if(this.contatto.row.categoriaprofessionale<1)
         this.contatto.row.categoriaprofessionale=''

      this.contatto.row.annolaurea = this.contatto.row.annolaurea.toString()

      await axios.query('query',`UPDATE statoiscrizione SET dbaction=1 WHERE dbaction=-1;`)
      return new Promise(async (resolve, reject) => {
         
         await this.getSi()
         await this.getNextquote()
         await this.getNextquoteDetail()
         await this.getRrinnovi()
         await this.getVersamenti()
         await this.getStatoiscrizione()
         await this.getAssicurazione()
         resolve("Fatto")
      })
   }

   checkEmail(emailCheck,contatto){
      return new Promise((resolve, reject) => {
        axios.query('fetchOne',`SELECT email FROM contatto WHERE email=→email AND id!=→contatto LIMIT 1`,{contatto:contatto,email:emailCheck},this,'pagine').then((response) => {
          var controllo = (response.result == emailCheck) ? false : true
          resolve(controllo)
        })
      })
    }

}
export default new socio
